module.exports = __webpack_public_path__ + "static/img/company_photo.6fabcd4.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/creator_bank/img/company_photo.jpg
// module id = MKJw
// module chunks = 0